import React, { useContext, useEffect, useState } from "react";
import { ReactComponent as PAYPALICON } from "../../../assets/icons/paypal_logo.svg";
import { ReactComponent as PAYPALLOGO } from "../../../assets/icons/PayPal-Orange.svg";
import { ReactComponent as TRASH } from "../../../assets/icons/Trash.svg";
import { ReactComponent as DELCARD } from "../../../assets/icons/Delete-card.svg";
import PopUpModal from "../../../NewComponents/PopUpModal";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { NotificationContext } from "../../../Context/NotificationContext";
import { auth, fieldValue, firestore } from "../../../firebase.config";

const PayPalBilling = ({ userData }) => {
  const { showNotification } = useContext(NotificationContext);

  const [deleteModalPayPal, setDeleteModalPayPal] = useState(null);
  const [deleteBtnText, setDeleteBtnText] = useState("Delete");
  const [showPayPalButtons, setShowPayPalButtons] = useState(false);
  const [{ isPending }] = usePayPalScriptReducer();
  const [paypalData,setPaypalData]=useState("");


  useEffect(() => {
    if (userData?.PaypalData?.length > 0) {
      setPaypalData(userData.PaypalData[0]); 
    }
  }, [userData]);

  const handleDeletePayPal = (data) => {
    setDeleteBtnText("Deleting...");
    firestore
      .collection("users")
      .doc(userData.id)
      .update({
        PaypalData: fieldValue.arrayRemove(data),
      })
      .then(() => {
        setDeleteBtnText("Deleted");
        setDeleteModalPayPal(null);
        setPaypalData(null);

      });
  };
  const createOrder = (data, actions) => {
    return actions.order.create({
      intent: "CAPTURE",
      purchase_units: [
        {
          description: `Your PayPal Details`,
          amount: {
            currency_code: "USD",
            value: '0.01',
          },

        },
      ],
      application_context: {
        brand_name: "eVerbary",
        landing_page: "NO_PREFERENCE",
        user_action: "PAY_NOW",
        payment_method: {
          payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED",
        },
      },
    });
  };

  const onOrderApprove = async (data, actions) => {
    const details = await actions.order.capture();

    if (details && details.payer) {
      const paypalUserData = {
        payerID: details.payer.payer_id,
        email: details.payer.email_address,
        name: `${details.payer.name.given_name} ${details.payer.name.surname}`,
      };


      try {
        const userRef = firestore
          .collection("users")
          .doc(auth.currentUser.uid);

        // Fetch the existing PaypalData field
        const userDoc = await userRef.get();

        let existingData = [];
        if (userDoc.exists) {
          const data = userDoc.data();
          existingData = Array.isArray(data.PaypalData) ? data.PaypalData : [];
        }

        // Check if payerID already exists
        const isDuplicate = existingData.some(
          (item) => item.payerID === paypalUserData.payerID
        );

        if (!isDuplicate) {
          // Add new data if payerID is not a duplicate
          existingData.push(paypalUserData);

          // Update Firestore
          await userRef.update({ PaypalData: existingData });
          setPaypalData(existingData);

          showNotification(
            "Information Saved",
            "PayPal data successfully added.",
            "success"
          );
          // } else {
          //     showNotification(
          //         "Information Unchanged",
          //         "This PayPal account is already linked.",
          //         "info"
          //     );
        }
      } catch (error) {
        console.log("Error updating PayPal data:", error);
        showNotification("Error", "Error updating PayPal data", "error");
      }
    }


  };

  const onOrderPaymentFailure = (data, actions) => {
    showNotification(
      "Error",
      "An error ocurred while adding paypal account. Please, try again.",
      "error"
    );
  };
  
  return (
    <>
      {deleteModalPayPal && (
        <PopUpModal
          title={"Delete PayPal Details"}
          backBtnText="Back to Payments"
          subText="Are you sure you want to delete this PayPal Details?"
          text={"This action cannot be undone."}
          btnText={deleteBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setDeleteModalPayPal(null)}
          onClick={() => {
            handleDeletePayPal(deleteModalPayPal);
          }}
          onBackClick={() => setDeleteModalPayPal(null)}
          disableBtn={deleteBtnText === "Deleting..."}
        >
          <DELCARD />
        </PopUpModal>
      )}
      {paypalData  ? (
        
          <div className="grid grid-cols-1 gap-4 w-full">
            {userData?.PaypalData?.map((el) => {
              return (
                <div className="border border-[#E6E7E9] md:py-4 p-2 md:px-6 rounded-md flex items-center gap-4 w-full">
                  <PAYPALLOGO />
                  <div className="flex justify-between w-full">
                    <div className="flex flex-col gap-1 items-start">
                      <div className="text-[#030F23] font-medium">
                        {el.name}
                      </div>
                      <div className="text-[#686F7B] text-[13px] ">
                        {el.email}
                      </div>
                    </div>

                    <div className="cursor-pointer" onClick={() => setDeleteModalPayPal(el)}>
                      <TRASH />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        
      ) : (
        <div className="grid grid-cols-1 gap-4">
          <p className="text-[#686F7B] max-w-screen-sm font-normal">
            Connecting to PayPal will simplify and speed up future payment
            processes by eliminating the need to re-enter payment information
            with every purchase.
          </p>

          {!showPayPalButtons ? (
            <button
              className='bg-[#0070ba] w-fit text-white border-none rounded-[20px] px-5 py-2 text-[16px] flex items-center gap-2 cursor-pointer'
              onClick={() => setShowPayPalButtons(true)}
            >
              <PAYPALICON /> Continue with PayPal
            </button>
          ) : (
            <div className='mt-4'>
              {isPending ? (
                <p>Loading PayPal<span className="dotsLoading">...</span></p>
              ) : (
                <PayPalButtons
                  createOrder={createOrder}
                  onApprove={onOrderApprove}
                  onError={onOrderPaymentFailure}
                  style={{ shape: 'pill', color: 'blue', label: 'paypal', height: 40 }}
                />
              )}
            </div>
          )}
        </div>
        
      )
      }
    </>
  );
};

export default PayPalBilling;



// import React, { useContext, useEffect, useState } from "react";
// import { ReactComponent as PAYPALICON } from "../../../assets/icons/paypal_logo.svg";
// import { ReactComponent as PAYPALLOGO } from "../../../assets/icons/PayPal-Orange.svg";
// import { ReactComponent as TRASH } from "../../../assets/icons/Trash.svg";
// import { ReactComponent as DELCARD } from "../../../assets/icons/Delete-card.svg";
// import PopUpModal from "../../../NewComponents/PopUpModal";
// import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
// import { NotificationContext } from "../../../Context/NotificationContext";
// import { auth, fieldValue, firestore, getFullHttpUrl } from "../../../firebase.config";
// import axios from "axios";
// import { DataContext } from "../../../Context/DataContext";

// const PayPalBilling = ({ userData, saveAccount = true, chargeAccount = false, afterOrderApprove = () => {} }) => {
//   const { showNotification } = useContext(NotificationContext);
//   const { teamData } = useContext(DataContext);

//   const [deleteModalPayPal, setDeleteModalPayPal] = useState(false);
//   const [billingToken, setBillingToken] = useState(null);
//   const [deleteBtnText, setDeleteBtnText] = useState("Delete");
//   const [showPayPalButtons, setShowPayPalButtons] = useState(false);
//   const [{ isPending }] = usePayPalScriptReducer();
//   const [paypalData,setPaypalData]=useState("");


//   useEffect(() => {
//     if(userData){
//       if(userData.teamId && teamData && teamData.paypalData){
//         setPaypalData(teamData.paypalData)
//       }else if(userData.paypalData){
//         setPaypalData(userData.paypalData); 

//       }
//     }
//   }, [userData, teamData]);


//   const handleDeletePayPal = () => {
//     setDeleteBtnText("Deleting...");
//     firestore
//       .collection(userData && userData.teamId ? "teams" :"users")
//       .doc(userData && userData.teamId ? userData.teamId : userData.id)
//       .update({
//         paypalData: null,
//       })
//       .then(() => {
//         setDeleteBtnText("Deleted");
//         setDeleteModalPayPal(null);
//         setPaypalData(null);

//       });
//   };
//   const createOrder = (data, actions) => {
//     return actions.order.create({
//       intent: "CAPTURE",
//       purchase_units: [
//         {
//           description: `Your PayPal Details`,
//           amount: {
//             currency_code: "USD",
//             value: '0.01',
//           },

//         },
//       ],
//       application_context: {
//         brand_name: "eVerbary",
//         landing_page: "NO_PREFERENCE",
//         user_action: "PAY_NOW",
//         payment_method: {
//           payee_preferred: "IMMEDIATE_PAYMENT_REQUIRED",
//         },
//       },
//     });
//   };

//   const onOrderApprove = async (data, actions) => {
//     console.log(data.billingToken, saveAccount);
    
//     if(saveAccount){
//       const res = await axios.post(getFullHttpUrl("paypal-getPaypalDetails"), {id: data.billingToken});
//       const paypalDetails = res.data;
//       const details = {
//               billingToken: data.billingToken,
//               payerID: data.payerID,
//               name: paypalDetails.name,
//               email: paypalDetails.email,
//               agreementID: paypalDetails.agreementID
//             };


//         try {
//           const userRef = firestore
//             .collection(userData && userData.teamId ? "teams" :"users")
//             .doc(userData && userData.teamId ? userData.teamId : userData.id);

//             console.log(paypalData)
//             // Update Firestore
//             await userRef.update({ paypalData: details });
//             setPaypalData(details);

//             showNotification(
//               "Information Saved",
//               "PayPal data successfully added.",
//               "success"
//             );
//         } catch (error) {
//           console.log("Error updating PayPal data:", error);
//           showNotification("Error", "Error updating PayPal data", "error");
//         }
//     }

//     if(chargeAccount){
//       afterOrderApprove(data.billingToken);
//     }
   
//   };

//   const onOrderPaymentFailure = (data, actions) => {
//     showNotification(
//       "Error",
//       "An error ocurred while placing the order. Please, try again.",
//       "error"
//     );
//   };

//   const createBillingAgreement = async() => {
//     return axios.post(getFullHttpUrl("paypal-createBillingAgreement")).then(res => {
//       // setBillingToken(res.data.billingToken);
//       // console.log(res.data.billingToken)
//       return res.data.billingToken
//     })
//   }
  
//   return (
//     <>
//       {deleteModalPayPal && (
//         <PopUpModal
//           title={"Delete PayPal Details"}
//           backBtnText="Back to Payments"
//           subText="Are you sure you want to delete this PayPal Details?"
//           text={"This action cannot be undone."}
//           btnText={deleteBtnText}
//           iconBgColor="#FFF6EA"
//           deleteBtn={true}
//           showClose
//           onClose={() => setDeleteModalPayPal(false)}
//           onClick={() => {
//             handleDeletePayPal();
//           }}
//           onBackClick={() => setDeleteModalPayPal(false)}
//           disableBtn={deleteBtnText === "Deleting..."}
//         >
//           <DELCARD />
//         </PopUpModal>
//       )}
//       {paypalData  ? (
//           <div className="grid grid-cols-1 gap-4 w-full">
//                 <div className="border border-[#E6E7E9] md:py-4 p-2 md:px-6 rounded-md flex items-center gap-4 w-full">
//                   <PAYPALLOGO />
//                   <div className="flex justify-between w-full">
//                     <div className="flex flex-col gap-1 items-start">
//                       <div className="text-[#030F23] font-medium">
//                         {paypalData.name}
//                       </div>
//                       <div className="text-[#686F7B] text-[13px] ">
//                         {paypalData.email}
//                       </div>
//                     </div>

//                     <div className="cursor-pointer" onClick={() => setDeleteModalPayPal(true)}>
//                       <TRASH />
//                     </div>
//                   </div>
//                 </div>
//           </div>
        
//       ) : (
//         <div className="grid grid-cols-1 gap-4">
//           <p className="text-[#686F7B] max-w-screen-sm font-normal">
//             Connecting to PayPal will simplify and speed up future payment
//             processes by eliminating the need to re-enter payment information
//             with every purchase.
//           </p>

//             <div className='mt-4'>
//               {isPending ? (
//                 <p>Loading PayPal<span className="dotsLoading">...</span></p>
//               ) : (
//                 <PayPalButtons
//                   fundingSource="paypal"
//                   // createBillingAgreement={createBillingAgreement}
//                   createOrder={createOrder}
//                   onApprove={(onOrderApprove)}
//                   onError={onOrderPaymentFailure}
//                   style={{ shape: 'pill', color: 'blue', label: 'paypal', height: 40 }}
//                 />
//               )}
//             </div>
//         </div>
        
//       )
//       }
//     </>
//   );
// };

// export default PayPalBilling;
